import React from "react";
import PropTypes from "prop-types";

export default function PaginatorTemplate({
                                              pageCount,
                                              hasPreviousPage,
                                              hasNextPage,
                                              start,
                                              end,
                                              onPageNumberChange,
                                              onPageSizeChange,
                                              onPaginatorPageNext,
                                              onPaginatorPagePrevious,
                                              onPaginatorSubmit,
                                              pageNumber,
                                              pageSize,
                                          }) {

    return <form className="form-inline pager-form"
                 onSubmit={onPaginatorSubmit}>
        <div className="col-md-4">
            {pageCount ?
                <div className="pull-left"><h4>Showing
                    results {start} to {end}</h4></div> :
                null
            }
        </div>

        <div className="text-center col-md-4">
            {hasPreviousPage ?
                <a href="#" className="btn btn-default pager-previousPage"
                   onClick={onPaginatorPagePrevious}>« Previous Page</a> :
                null
            }
            {pageCount ?
                <label className="control-label">Page <input
                    className="form-control pager-page input-mini"
                    type="text"
                    onChange={onPageNumberChange}
                    value={pageNumber} />
                    of {pageCount}</label> :
                null
            }
            {hasNextPage ?
                <a href="#" className="btn btn-default pager-nextPage"
                   onClick={onPaginatorPageNext}>Next Page »</a> :
                null
            }
        </div>

        <div className="col-md-4">
            <div className="pull-right">
                {pageCount ?
                    <label className="control-label">Results per Page <input
                        className="form-control pager-page-size input-mini"
                        type="text"
                        onChange={onPageSizeChange}
                        value={pageSize} /></label> :
                    null
                }

                {pageCount ?
                    <button type="submit" className="btn btn-refresh">
                        <span></span> Reload</button> :
                    null
                }
            </div>
        </div>
    </form>;
}

PaginatorTemplate.propTypes = {
    pageCount: PropTypes.number,
    hasPreviousPage: PropTypes.bool.isRequired,
    hasNextPage: PropTypes.bool.isRequired,
    start: PropTypes.number.isRequired,
    end: PropTypes.number.isRequired,
    onPageNumberChange: PropTypes.func.isRequired,
    onPageSizeChange: PropTypes.func.isRequired,
    onPaginatorPageNext: PropTypes.func.isRequired,
    onPaginatorPagePrevious: PropTypes.func.isRequired,
    onPaginatorSubmit: PropTypes.func.isRequired,
    pageNumber: PropTypes.string,
    pageSize: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/lib/dqr/views/results/lib/paginator/templates/PaginatorTemplate.js